import { parseGameLayers, type GameLayer } from '@b1fr0st/contracts/game-layers';
import type { GameLike } from './GameCard.js';
import { isLotteryGame } from './lotteryArt.js';
import { cardTile } from './tileImage.js';

/** Share of a tile's height a row keeps clear above it for a popout layer. */
const POPOUT_HEADROOM = 0.3;

export function hasPopoutLayer(layers: readonly GameLayer[] | null): boolean {
  return layers?.some((l) => l.popout) ?? false;
}

/**
 * Extra top padding a sideways-scrolling row needs for its popout tiles: an
 * overflow-x scroller clips vertical overflow too. Zero when no tile in the
 * row pops, so those rows keep their old height. Lottery cards never draw
 * layers, nor does a card with a Tile or a theme card due at `now` (its layers
 * are in the picture), and every other card is a 3:4 tile at the row's card
 * width.
 */
export function popoutHeadroomPx(games: readonly GameLike[], tileWidthPx: number, now: Date): number {
  const popout = games.some((g) => !isLotteryGame(g) && !cardTile(g, now) && hasPopoutLayer(parseGameLayers(g.layers)));
  return popout ? Math.round(((tileWidthPx * 4) / 3) * POPOUT_HEADROOM) : 0;
}
